import Clarity from '@microsoft/clarity'

export default () => {
  if (process.env.ENVIRONMENT !== 'production') return

  Clarity.init(process.env.CLARITY_KEY)
}
